import * as React from 'react';
import { Query } from '@apollo/client/react/components';
import { QueryResult } from '@apollo/client/react';
import ExitSurveyMetadataQuery from '../ExitSurveyMetadata';
import { Props, QueryResponse } from './types';

const query = require('./query.graphql');

class MetadataQueryComponent extends React.PureComponent<Props> {
  render() {
    const { children } = this.props;

    return (
      <ExitSurveyMetadataQuery>
        {({ exitSurveySources, loading: exitSurveyLoading }) => (
          <Query query={query}>
            {({ data, loading: metadataLoading }: QueryResult<QueryResponse>) => {
              if (exitSurveyLoading || metadataLoading) {
                return children({
                  ...this.props,
                  metadata: null,
                  loading: exitSurveyLoading || metadataLoading,
                });
              }

              return children({
                metadata: {
                  ...data.metadata,
                  exitSurveySources: exitSurveySources && exitSurveySources.list,
                },
                loading: exitSurveyLoading || metadataLoading,
              });
            }}
          </Query>
        )}
      </ExitSurveyMetadataQuery>
    );
  }
}

export default MetadataQueryComponent;
